import { StudentCertificate, StudentCertificateFile } from '@/interfaces/studentCertificate';
import { PaginatedResponse } from '@/interfaces/response';
import { Note } from '@/interfaces/note';
import { AxiosPromise } from 'axios';
import request from '@/umi-request';

export async function uploadStudentCertificate(affiliate: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/regular-student-certificate/`,
    method: 'POST',
    data
  }) as AxiosPromise<StudentCertificate>;
}

export async function uploadFile(affiliate: number, data: any) {
  return request({
    url:`affiliates/${affiliate}/regular-student-certificate/upload-file/`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  }) as AxiosPromise<StudentCertificateFile>;
}

export async function cancelStudentCertificate(affiliate: number, id: number) {
  return request({
    url:`affiliates/${affiliate}/regular-student-certificate/${id}/cancel/`,
    method: 'POST',
  }) as AxiosPromise<StudentCertificate>;
}

export async function updateStudentCertificate(affiliate: number, id: number, data: any) {
  return request({
    url: `affiliates/${affiliate}/regular-student-certificate/${id}/update/`,
    method: 'PATCH',
    data: { ...data }
  }) as AxiosPromise<StudentCertificate>;
}

export async function queryStudentCertificates(params: any) {
  return request({
    url: `regular-student-certificate/`,
    method: 'GET',
    params
  }) as AxiosPromise<PaginatedResponse<StudentCertificate>>;
}

export async function queryStudentCertificate(id: number | string) {
  return request({
    url: `regular-student-certificate/${id}/`,
    method: 'GET'
  }) as AxiosPromise<StudentCertificate>;
}

export async function updateStudentCertificateStatus(id: number | string, data: any) {
  return request({
    url: `regular-student-certificate/${id}/`,
    method: 'PATCH',
    data
  }) as AxiosPromise<StudentCertificate>;
}

export async function queryStudentCertificatesChangesHistory(id: number | string) {
  return request({
    url: `regular-student-certificate/${id}/changes-history/`,
    method: 'GET',
  }) as AxiosPromise<StudentCertificate[]>;
}

export async function queryStudentCertificateHistory(id: number | string) {
  return request({
    url: `regular-student-certificate/${id}/history/`,
    method: 'GET',
  }) as AxiosPromise<StudentCertificate[]>;
}

export async function sendStudentCertificateNote(id: number | string, data: { content: string }) {
  return request({
    url: `regular-student-certificate/${id}/notes/`,
    method: 'POST',
    data
  }) as AxiosPromise<Note<StudentCertificate>>;
}

export async function getStudentCertificateNotes(id: number | string) {
  return request({
    url: `regular-student-certificate/${id}/notes/`,
    method: 'GET'
  }) as AxiosPromise<Note<StudentCertificate>[]>;
}